export const FETCH_USER = 'FETCH_USER';

export const SET_SHOW_SEND_MASSAGE = 'SET_SHOW_SEND_MASSAGE';
export const SET_SHOW_LOGIN = 'SET_SHOW_LOGIN';
export const SET_SHOW_ALERT = 'SET_SHOW_ALERT';
export const SET_SHOW_LIST_ADDER = 'SET_SHOW_LIST_ADDER';
export const SET_LOCATION = 'SET_LOCATION';
export const SET_SHOW_SPINNER = 'SET_SHOW_SPINNER';

export const SET_BACKGROUND_COLOR = 'SET_BACKGROUND_COLOR';
